<template>
  <div id="ACTIVITY">
    <div class="common-title" id="ACTIVITY">
      <div class="common-title-content">
        行业活动
      </div>
    </div>
    <div class="tab-panel">
      <div class="smcaiot-photo-wall">
        <div class="image-item business1">
          <img src="@/assets/images/newsCenter/business1.png" alt="" />
          <div class="content">
            <div class="text">
              2020戴尔科技峰会：<br />以科技之名·致敬攀登者
            </div>
          </div>
        </div>
        <div class="image-item business2">
          <img src="@/assets/images/newsCenter/business2.png" alt="" />
          <div class="content">
            <div class="text">金钥匙——面向中国的SDG行动</div>
          </div>
        </div>
        <div class="image-item business3">
          <img src="@/assets/images/newsCenter/business3.png" alt="" />
          <div class="content">
            <div class="text">第三届中国国际进口博览会</div>
          </div>
        </div>
        <div class="image-item business4">
          <img src="@/assets/images/newsCenter/business4.jpg" alt="" />
          <div class="content">
            <div class="text">
              IOTE 2021<br />
              第十六届国际物联网展·深圳站
            </div>
          </div>
        </div>
        <div class="image-item business5">
          <img src="@/assets/images/newsCenter/business5.png" alt="" />
          <div class="content">
            <div class="text">第四届“北斗”创新创业大赛</div>
          </div>
        </div>
        <div class="image-item business6">
          <img src="@/assets/images/newsCenter/business6.png" alt="" />
          <div class="content">
            <div class="text">第二届天津公安<br />科技创新成果展</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "news-center",
  data() {
    return {
      visitTabs: [
        {
          text: "行业活动",
          value: 1
        },
        {
          text: "领导关怀",
          value: 2
        }
      ],
      currentTab: 1,
      swiperOption: {
        // some swiper options/callbacks
        // 所有的参数同 swiper 官方 api 参数
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        loop: true,
        slidesPerView: 3,
        // spaceBetween: -180,
        centeredSlides: true,
        centeredSlidesBounds: true,
        autoplay: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      }
    };
  },
  methods: {
    handleTabClick(param) {
      this.currentTab = param.value;
    }
  }
};
</script>

<style lang="less" scoped>
.swiper-container {
  padding-bottom: 3rem;
}
.swiper-container .swiper-wrapper .swiper-slide {
  width: 43.4rem;
  height: 30.15rem;
  transform: scale(0.8);
}
.swiper-container .swiper-wrapper .swiper-slide-active {
  width: 43.4rem;
  height: 30.15rem;
  transform: scale(1);
  z-index: 99 !important;
}
.swiper-pagination {
  bottom: 0.79rem !important;
}
.swiper-pagination-bullet {
  width: 2.38rem;
  height: 0.31rem;
  border-radius: 1px;
  background-color: #a2a2a2;
}
.swiper-pagination-bullet-active {
  background-color: #fff;
}
.swiper-main {
  width: 73rem;
  margin: 0 auto;
}
.swiper-item-content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  .swiper-item-slide {
    position: relative;
    width: 100%;
    height: 100%;
    .img {
      display: flex;
      align-items: center;
      width: 100%;
      height: 25.75rem;
      background-color: #f2f3f5;
      img {
        width: 100%;
      }
    }
    .text {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 4.4rem;
      line-height: 4.4rem;
      font-size: 0.9rem;
      color: #ffffff;
      text-align: center;
      background-color: #2f61ae;
    }
  }
}
.tab-panel {
  padding-bottom: 6rem;
}
.smcaiot-photo-wall {
  position: relative;
  width: 73.05rem;
  height: 37.5rem;
  margin: 0 auto;
  .image-item {
    position: absolute;
    cursor: pointer;
    z-index: 99;
    &:hover {
      .content {
        visibility: visible;
        .text {
          opacity: 1;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
    .content {
      visibility: hidden;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 100;
      width: 100%;
      height: 100%;
      background-color: #2f61ae;
      font-size: 1.2rem;
      color: #ffffff;
      overflow: hidden;
      .text {
        position: absolute;
        top: 55%;
        width: 100%;
        padding: 0 2rem;
        line-height: 1.65rem;
        text-align: center;
        opacity: 0;
        transition: all 0.4s ease-in;
      }
    }
    &.business1 {
      top: 0;
      left: 0;
      width: 25.15rem;
      height: 18.75rem;
    }
    &.business2 {
      top: 0;
      left: 25.15rem;
      width: 21.85rem;
      height: 23.5rem;
    }
    &.business3 {
      top: 0;
      right: 0;
      width: 26.05rem;
      height: 23.5rem;
    }
    &.business4 {
      top: 18.75rem;
      left: 0;
      width: 25.15rem;
      height: 18.75rem;
    }
    &.business5 {
      top: 23.5rem;
      left: 25.15rem;
      width: 34rem;
      height: 14rem;
    }
    &.business6 {
      top: 23.5rem;
      right: 0;
      width: 13.9rem;
      height: 14rem;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
